goog.provide('el8.ptdata.rxRefillRequests');

goog.require('el8.model.base');
goog.require('el8.data.medications');
goog.require('el8.data.pharmacies');
goog.require('el8.ptdata.denialMedOrders');
goog.require('el8.ptdata.model.med.medOrder');
goog.require('el8.util.base');

/**
 * This model is used to hold either "prescribed medication" or "dispensed medication" in a refill request
 */
(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);

        if (spec.medication) {
            this.setMedication(el8.data.medications.create(spec.medication));
        }
    };

    _class.addProperty('medication');
    _class.addStringProperty('requestedMedicationName');
    _class.addStringProperty('requestedRefillType');

    _class.addBoolean('allowSubstitutions', false, null);
    _class.addIntProperty('requestedRefills');
    _class.addBoolean('prn');
    _class.addBoolean('controlled');
    _class.addIntProperty('deaSchedule');
    _class.addStringProperty("daysSupply");
    _class.addStringProperty("quantity", true);
    _class.addStringProperty("quantityUnits", true);
    _class.addStringProperty('directions');
    _class.addStringProperty('note');
    _class.addStringProperty('displaySubstitutions');
    _class.addStringProperty('writtenDate');  // pre-formatted by server
    _class.addStringProperty('lastFillDate'); // pre-formmated by server

    _class.prototype.getDisplayQuantity = function(wordy) {
        wordy = (wordy !== false); // defaults to true
        return this.getQuantity() +
            (this.getQuantityUnits() ? ' ' + this.getQuantityUnits() :
                (wordy ? ' (units not specified)' : ''));
    };
    _class.prototype.getAuthRefills = function() {
        // If requested refills is not null and is positive, return 1 minus
        if (this.getRequestedRefills() > 0) {
            return this.getRequestedRefills() - 1;
        // Otherwise, return 0
        } else {
            return 0;
        }
    };
    _class.prototype.asSoyMap = function() {
        var result = this.parent.asSoyMap.call(this);
        result['authRefills'] = this.getAuthRefills();
        return result;
    };

    el8.ptdata.model.rxRefillRequestMedication = function(spec) { return new _class(spec); };

})();


el8.ptdata.rxRefillRequests = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);
        this.setOriginalSpec(spec);
        if (spec.requested_pharmacy) {
            this.setPharmacyNcpdpid(spec.requested_pharmacy.ncpdpid);
            this.setPharmacyName(spec.requested_pharmacy.store_name);
            this.setPharmacyAddress1(spec.requested_pharmacy.address1);
            this.setPharmacyAddress2(spec.requested_pharmacy.address2);
            this.setPharmacyCity(spec.requested_pharmacy.city);
            this.setPharmacyState(spec.requested_pharmacy.state);
            this.setPharmacyZip(spec.requested_pharmacy.zip);
            this.setPharmacyPhone(spec.requested_pharmacy.primary_phone);
            this.setPharmacyFax(spec.requested_pharmacy.fax);
        }

        if (spec.original_med_order) {
            this.setOriginalMedOrder(el8.ptdata.model.med.medOrder(spec.original_med_order));
        }

        if (spec.prescribed_medication) {
            this.setPrescribedMedication(el8.ptdata.model.rxRefillRequestMedication(spec.prescribed_medication));
        }

        if (spec.dispensed_medication) {
            this.setDispensedMedication(el8.ptdata.model.rxRefillRequestMedication(spec.dispensed_medication));
        }
    };
    _class.addProperty('originalSpec'); // useful for rendering

    _class.addStringProperty('prescriberName');
    _class.addIntProperty('prescriberId');

    _class.addProperty('originalMedOrder');

    // there are 2 types of medication now in 10.6 -- Prescribed vs Dispensed
    _class.addProperty('prescribedMedication');
    _class.addProperty('dispensedMedication');

    // a flag to indicate whether dispensed is the same as prescribed.  this is done by comparing NDC
    _class.addBoolean('dispensedAsPrescribed');

    // A medication can be controlled only in the pharmacy's state,
    // thus this flag can be different from the isControlled flag of a medication.
    _class.addBoolean('requestForControlledMed');

    _class.addStringProperty('pharmacyNcpdpid');
    _class.addStringProperty('pharmacyName');
    _class.addStringProperty('pharmacyAddress1');
    _class.addStringProperty('pharmacyAddress2');
    _class.addStringProperty('pharmacyCity');
    _class.addStringProperty('pharmacyState');
    _class.addStringProperty('pharmacyZip');
    _class.addStringProperty('pharmacyPhone');
    _class.addStringProperty('pharmacyFax');
    _class.addStringProperty('followupNumber');

    /**
     * The following methods are proxies that delegate to DispensedMedication
     */
    _class.prototype.getMedication = function() {
        return this.getDispensedMedication().getMedication();
    };
    _class.prototype.getRequestedMedicationName = function() {
        return this.getDispensedMedication().getRequestedMedicationName();
    };
    _class.prototype.getRequestedRefillType = function() {
        return this.getDispensedMedication().getRequestedRefillType();
    };
    _class.prototype.getRequestedRefills = function() {
        return this.getDispensedMedication().getRequestedRefills();
    };
    _class.prototype.isPrn = function() {
        return this.getDispensedMedication().isPrn();
    };
    _class.prototype.getWrittenDate = function() {
        return this.getDispensedMedication().getWrittenDate();
    };
    _class.prototype.getLastFillDate = function() {
        return this.getDispensedMedication().getLastFillDate();
    };
    _class.prototype.getQuantity = function() {
        return this.getDispensedMedication().getQuantity();
    };
    _class.prototype.getQuantityUnits = function() {
        return this.getDispensedMedication().getQuantityUnits();
    };
    _class.prototype.getDaysSupply = function() {
        return this.getDispensedMedication().getDaysSupply();
    };
    _class.prototype.getDirections = function() {
        return this.getDispensedMedication().getDirections();
    };
    _class.prototype.getNote = function() {
        return this.getDispensedMedication().getNote();
    };
    _class.prototype.getDisplaySubstitutions = function() {
        return this.getDispensedMedication().getDisplaySubstitutions();
    };
    _class.prototype.isAllowSubstitutions = function() {
        return this.getDispensedMedication().isAllowSubstitutions();
    };
    _class.prototype.getInstructions = function() {
       return this.getOriginalMedOrder() ?
           this.getOriginalMedOrder().getPatientInstructions() : '';
    };
    _class.prototype.getDisplayQuantity = function(wordy) {
        return this.getDispensedMedication().getDisplayQuantity();
    };

    /**
     * *IMPORTANT* These are "requestedRefills" in Surescripts language.
     *     For us, they are 1 plus what we normally call "authRefills".
     *     "requestedRefills" = the current dispense + additional refills
     *
     *     There is a method getAuthRefills() below to compute Elation authRefills
     */

    _class.addBoolean('readyToAccept');
    _class.addDateTime('receivedTime');


    _class.prototype.getPharmacyAddressLine = function() {
        return (this.getPharmacyAddress1() +
            (this.getPharmacyAddress2() ? ' '+this.getPharmacyAddress2() : ''));
    };
    _class.prototype.getPharmacyCityStateZip = function() {
        if (!this.getPharmacyCity() && !this.getPharmacyState() && !this.getPharmacyZip()) { return ''; }
        return (this.getPharmacyCity()+', '+this.getPharmacyState()+' '+this.getPharmacyZip());
    };
    _class.prototype.getMedicationId = function() {
        return this.getMedication() ? this.getMedication().getId() : null;
    };
    _class.prototype.isAssignedTo = function(physicianId) {
        return physicianId === this.getPrescriberId();
    };

    /**
     * These methods are for dealing with controlled substances
     */
    _class.prototype.getMedicationDeaSchedule = function() {
        if (this.getDispensedMedication().getDeaSchedule()) {
            return this.getDispensedMedication().getDeaSchedule();
        }

        return this.getMedication() && this.getMedication().isControlled() ?
                    this.getMedication().getDeaSchedule() : null;
    };
    _class.prototype.isControlledRefillPrintOnly = function() {
        return this.getMedicationDeaSchedule() && this.getMedicationDeaSchedule() === 2;
    };
    _class.prototype.isMedicationControlled = function() {
        if (this.getDispensedMedication().isControlled()) {
            return true;
        }
        return this.isRequestForControlledMed();
    };

    /**
     * Useful method for maintaining distinction with Surescripts refills
     */

    _class.prototype.getAuthRefills = function() {
        return this.getDispensedMedication().getAuthRefills();
    };

    _class.prototype.asSoyMap = function() {
        return {
            medication: this.getRequestedMedicationName(),
            directions: this.getDirections(),
            qty: this.getDisplayQuantity(),
            displaySubstitutions: this.getDisplaySubstitutions(),
            daysSupply: this.getDaysSupply(),
            prescriberName: this.getPrescriberName(),
            pharmacy: {
                name: this.getPharmacyName(),
                addressLine: this.getPharmacyAddressLine(),
                cityStateZip: this.getPharmacyCityStateZip(),
                phone: this.getPharmacyPhone(),
                fax: this.getPharmacyFax()
            }
        };
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlFn: function(id) {
            return el8.service.urls.get('rxRefillRequests', [id]);
        }
    });

    that.submitApproval = function(item, authRefills, note, noChange, callbackFn) {
        var json = {};
        if (noChange) {
            json['approve_no_change'] = true;
        } else {
            if (authRefills || (parseInt(authRefills, 10) === 0)) { json['authRefills'] = authRefills; }
            if (note) { json['note'] = note; }
        }
        var newOrder = null;
        $.el8_ajax({
            url: el8Globals['PATIENT_PATH']+'rxrefill/'+item.getId()+'/approve/',
            type: "POST",
            // Doh. Because callbackFn usually involves a window.open, we make this async=false
            // and call the callbackFn at the very end, outside the ajax call
            async: false,
            data: JSON.stringify(json),
            success: function(data) {

                el8.ptdata.rxRefillRequests.remove(item); /* notifies */
                var newThread = el8.ptdata.medOrderThreads.create(data['thread']); /* notifies */
                newOrder = newThread.getLatestMedOrder();

                el8.ptdata.medOrders.trigger(EVENTS.CREATED, newOrder);

                el8.ptdata.ptPreferences.refresh();
                // Add Poller so that state gets updated
                el8.ptdata.medOrders.addERxPoller([newOrder.getId()]);
            }
        });
        if (callbackFn) { callbackFn(newOrder); }
    };

    that.submitControlledApproval = function(item, authRefills, note, noChange, callbackFn) {
        var json = {};
        if (noChange) {
            json['approve_no_change'] = true;
        } else {
            if (authRefills || (parseInt(authRefills, 10) === 0)) { json['authRefills'] = authRefills; }
            if (note) { json['note'] = note; }
        }
        var newOrder = null;
        $.el8_ajax({
            url: el8Globals['PATIENT_PATH']+'rxrefill/'+item.getId()+'/approve-controlled/',
            type: "POST",
            // Doh. Because callbackFn usually involves a window.open, we make this async=false
            // and call the callbackFn at the very end, outside the ajax call
            async: false,
            data: JSON.stringify(json),
            success: function(data) {
                var url = data.params.url;

                //el8.ptdata.rxRefillRequests.remove(item); can't remove the refill request yet since we need MDT iframe to finish 1st
                var newThread = el8.ptdata.medOrderThreads.create(data['thread']); /* notifies */
                newOrder = el8.ptdata.medOrders.create(data['order']);

                el8.app.shared.dialog.epcsApprove.show({
                    // This shows the final "enter your PW and TFA code" screen which
                    // is what we want. 'RxSendCs' will show that with the meds summary
                    // screen behind it which is useful for testing
                    url: url + '?' + $.param($.extend({page: 'RefillReqCs'}, data.params)),
                    medOrderIds: [newOrder.getId()]
                });

                //el8.ptdata.medOrders.trigger(EVENTS.CREATED, newOrder);

                el8.ptdata.ptPreferences.refresh();
                // Add Poller so that state gets updated
                el8.ptdata.medOrders.addERxPoller([newOrder.getId()]);
            }
        });
        if (callbackFn) { callbackFn(newOrder); }
    };

    that.submitDenial = function(item, note) {
        var json = {'note': note};
        $.el8_ajax({
            url: el8Globals['PATIENT_PATH']+'rxrefill/'+item.getId()+'/deny/',
            type: "POST",
            data: JSON.stringify(json),
            success: function(data) {
                el8.ptdata.rxRefillRequests.remove(item); /* notifies */
                var denial = el8.ptdata.denialMedOrders.create(data);  /* notifies */
                el8.ptdata.denialMedOrders.addERxPoller([denial]);
            }
        });
    };

    return that;

})();
